import $ from 'jquery';
import config from './config';

let dropdowns = {};
let signtypeNum = {};
let signTypeDesc = {};

export default class DropdownLib {

    // initialize this on page load.
    static intialize(lateLoading) {

        lateLoading(true);

        

        $.ajax({
            type: 'GET',
            url: `${config.server}\\dropdown\\`,
            contentType: 'application/json',
            success: (data) => {
                //console.log(data)
                // some javascript magic happens here.
                for (let c of data)
                {
                    
                    
                        if (!dropdowns[c.LayerTable])
                        {
                            dropdowns[c.LayerTable] = {};
                            // console.log(`creating ${c.LayerTable}`);
                        }

                        if (!dropdowns[c.LayerTable][c.OptionName]) {
                            dropdowns[c.LayerTable][c.OptionName] = [];
                            // console.log(`creating ${c.OptionName}`);
                        }                       
                        
                        dropdowns[c.LayerTable][c.OptionName].push({
                            key: c.OptionKey,
                            value: c.OptionKey,
                            label: c.OptionValue,
                            isSelected: false
                        }); 

                        if (!signtypeNum[c.LayerTable])
                        {
                            signtypeNum[c.LayerTable] = {};
                            // console.log(`creating ${c.LayerTable}`);
                        }

                        if (!signtypeNum[c.LayerTable][c.OptionName]) {
                            signtypeNum[c.LayerTable][c.OptionName] = [];
                            // console.log(`creating ${c.OptionName}`);
                        }                       
                        
                        signtypeNum[c.LayerTable][c.OptionName].push({
                            key: c.OptionKey,
                            value: c.OptionKey,
                            label: c.OptionCode,
                            isSelected: false
                        });
                        
                        if (!signTypeDesc[c.LayerTable])
                        {
                            signTypeDesc[c.LayerTable] = {};
                            // console.log(`creating ${c.LayerTable}`);
                        }

                        if (!signTypeDesc[c.LayerTable][c.OptionName]) {
                            signTypeDesc[c.LayerTable][c.OptionName] = [];
                            // console.log(`creating ${c.OptionName}`);
                        }                       
                        
                        signTypeDesc[c.LayerTable][c.OptionName].push({
                            key: c.OptionKey,
                            value: c.OptionKey,
                            label: c.OptionValue,
                            isSelected: false
                        }); 
                
                }
                lateLoading(false);
            },
        });

    }
    

    static getDropdowns()
    {     
        return dropdowns;
    }

    static getSignNum(){
        return signtypeNum;
    }

    static getSignTypeDesc(){
        return signTypeDesc;
    }

}





// WEBPACK FOOTER //
// ./src/DropdownLib.js